import React from "react";
import { useLocation } from 'react-router-dom';
import { BASE_NAME } from "../routes";

const IndexButton = ({name, sectionRef, goHome}) => {
  const location = useLocation();
  const pathname = location.pathname;

  const scrollToSection = (alignment) => {
    if (sectionRef && sectionRef.current) {
        sectionRef.current.scrollIntoView(alignment);
    }
  };

  const handleButtonClick = (e) => {
    e.preventDefault();
    if (pathname !== BASE_NAME) {
      goHome(sectionRef)
    } else {
      scrollToSection({ behavior: 'smooth', block: 'start', inline: 'center'});
    }
  };

  return (
    <button
        className="w-48 hover:text-blueGray-500 text-blueGray-700 px-5 py-4 lg:py-2 lg:px-10 flex items-center text-xs uppercase font-bold"
        onClick={handleButtonClick}
      >
        {name}
      </button> 
  )
}

export default IndexButton;
